export { PaymentIcon } from './PaymentIcon'
